/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Support_Attachments_LabelInputs */

const en_common_support_attachments_label = /** @type {(inputs: Common_Support_Attachments_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Images (optional)`)
};

const zh_common_support_attachments_label = /** @type {(inputs: Common_Support_Attachments_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`图片附件(可选)`)
};

/**
* | output |
* | --- |
* | "Images (optional)" |
*
* @param {Common_Support_Attachments_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_support_attachments_label = /** @type {((inputs?: Common_Support_Attachments_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Support_Attachments_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_support_attachments_label(inputs)
	return zh_common_support_attachments_label(inputs)
});
export { common_support_attachments_label as "common.support.attachments_label" }